export default function OneCredentialDelinkSuccessImage() {
  return null;
}
